import { render } from "./Producto.vue?vue&type=template&id=21666595&scoped=true"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"

import "./Producto.vue?vue&type=style&index=0&id=21666595&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21666595"

export default script